<template>
    <div>
        <pagamentos-filtros
            @aplicarFiltro="aplicarFiltro($event)"
        ></pagamentos-filtros>
        <b-row>
            <b-col sm="12" md="6" lg="4">
                <app-painel-valor
                    :valor="totalLiquido"
                    titulo="Total Líquido"
                    cor="primary"
                ></app-painel-valor>
            </b-col>
            <b-col sm="12" md="6" lg="4">
                <app-painel-valor
                    :valor="totalLiquidoQuitado"
                    titulo="Total Líquido Quitado"
                    cor="success"
                ></app-painel-valor>
            </b-col>
            <b-col sm="12" md="6" lg="4">
                <app-painel-valor
                    :valor="totalLiquidoProgramado"
                    titulo="Total Líquido Programado"
                    cor="warning"
                ></app-painel-valor>
            </b-col>
        </b-row>
        <pagamentos-tabela :pagamentos="pagamentosFiltrados">
            <template slot="titulo">
                <btn-exportar
                    class="float-right"
                    :desabilitar="pagamentosFiltrados.length == 0"
                    :dataInicial="filtro ? filtro.dataInicial : ''"
                    :dataFinal="filtro ? filtro.dataFinal : ''"
                    :status="statusSelecionado"
                    :fornecedorId="fornecedorId"
                    :dataServico="dataServico"
                ></btn-exportar>
            </template>
            <template slot="botoes">
                <!-- <b-row> -->
                <!-- <b-col sm="12"> -->
                <b-form inline class="justify-content-end">
                    <label class="mr-sm-2">Status</label>
                    <b-form-select
                        class="mb-2 mr-sm-2 mb-sm-0"
                        :plain="true"
                        :options="statusLista"
                        v-model="statusSelecionado"
                    ></b-form-select>
                </b-form>
                <!-- </b-col> -->
                <!-- </b-row> -->
            </template>
            <template slot="acoes" slot-scope="data">
                <btn-recibos
                    :pagamento="data"
                    :dataServico="obterServico()"
                    :fornecedorId="fornecedorId"
                ></btn-recibos>
            </template>
        </pagamentos-tabela>
    </div>
</template>

<script>
import PagamentosServicos from './PagamentosServicos'
import PagamentosTabela from './PagamentosTabela'
import PagamentosFiltros from './PagamentosFiltros'
import BtnExportar from './BtnExportar'
import BtnRecibos from './BtnRecibos.vue'

export default {
    props: {
        fornecedorId: {
            type: String,
            default: () => null
        },

        dataServico: {
            type: Object,
            default: () => {}
        }
    },

    components: {
        PagamentosTabela,
        PagamentosFiltros,
        BtnExportar,
        BtnRecibos
    },

    data() {
        return {
            pagamentos: [],
            pagamentosFiltrados: [],
            totalLiquido: 0,
            totalLiquidoQuitado: 0,
            totalLiquidoProgramado: 0,
            filtro: null,
            statusSelecionado: 0,
            statusLista: [
                { value: 0, text: 'TODOS' },
                { value: 1, text: 'PROGRAMADO' },
                { value: 2, text: 'QUITADO' }
            ]
        }
    },

    methods: {
        obterPagamentos(filtro) {
            this.$store.dispatch('addRequest')
            let promisse
            if (this.fornecedorId) {
                promisse = this.dataServico.obterPagamentosRm(
                    this.fornecedorId,
                    filtro
                )
            } else {
                promisse = PagamentosServicos.obterTodos(filtro)
            }
            promisse.then(response => {
                if (response) {
                    if (response.success) {
                        this.pagamentos = response.data.pagamentos
                        this.totalLiquido = response.data.totalLiquido
                        this.totalLiquidoQuitado =
                            response.data.totalLiquidoQuitado
                        this.totalLiquidoProgramado =
                            response.data.totalLiquidoProgramado
                        this.aplicarFiltroStatus()
                    } else {
                        this.$toast.error(
                            response.errors,
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        aplicarFiltro(filtro) {
            this.filtro = filtro
            this.obterPagamentos(filtro)
        },

        aplicarFiltroStatus() {
            if (this.statusSelecionado == 0) {
                this.pagamentosFiltrados = this.pagamentos
            } else {
                this.pagamentosFiltrados = this.pagamentos.filter(item => {
                    return item.status == this.statusSelecionado
                })
            }
        },

        obterServico() {
            if (this.fornecedorId) {
                return this.dataServico
            }
            return PagamentosServicos
        }
    },

    created() {},

    computed: {},

    watch: {
        statusSelecionado() {
            this.aplicarFiltroStatus()
        }
    }
}
</script>
